import { useQueryClient } from "@tanstack/react-query";
import { Package, PackageCheck, PackageOpen } from "lucide-react";
import { api } from "@/lib/api";
import { useErrorToast } from "@/lib/hooks";
import { useWs } from "@/context/Auth";
import { useI18n } from "@/i18n/I18n";
import { cn } from "@/lib/utils";

export const MOVE_STATES = [
  [null, "move.todo", Package, "bg-slate-900 text-white"],
  ["packed", "move.packed", PackageCheck, "bg-amber-400 text-slate-900"],
  ["unpacked", "move.unpacked", PackageOpen, "bg-emerald-500 text-white"],
];

export const MoveStatusToggle = ({ loc, compact = false }) => {
  const { t } = useI18n();
  const qc = useQueryClient();
  const { canWrite } = useWs();
  const showErr = useErrorToast();
  const current = loc.move_status || null;
  const set = async (status) => {
    try {
      await api.put(`/locations/${loc.id}/move-status`, { status });
      qc.invalidateQueries({ queryKey: ["locations"] });
      qc.invalidateQueries({ queryKey: ["location", loc.id] });
    } catch (e) { showErr(e); }
  };
  return (
    <div className={cn(!compact && "rounded-2xl border border-slate-200 bg-white p-4 space-y-3")} data-testid={`move-toggle-${loc.id}`}>
      {!compact && <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{t("move.status")}</p>}
      <div className="grid grid-cols-3 gap-1 rounded-xl bg-slate-100 p-1">
        {MOVE_STATES.map(([v, k, Icon, active]) => (
          <button key={k} disabled={!canWrite} data-testid={`move-set-${v || "todo"}-${loc.id}`} onClick={() => set(v)}
            className={cn("flex items-center justify-center gap-1.5 rounded-lg px-2 font-semibold transition-colors", compact ? "py-2 text-[11px]" : "py-3 text-xs",
              current === v ? active : "text-slate-500 hover:bg-white")}>
            <Icon className="w-4 h-4 shrink-0" /><span className={compact ? "leading-tight text-start" : "truncate"}>{t(k)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
